import React from "react";
import { formatChannelList } from "src/utils/FormatUtil";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setStockName } from "src/store/sessionStore";

interface StockTableProps {
    contents: {
        isu_kor_abbrv?: string;
        channels?: string;
        cnt?: number;
        isu_srt_cd?: string;
        recommend?: boolean;
    }[];
}

const StockTable: React.FC<StockTableProps> = ({ contents }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleClick = (path: string, isu_kor_abbrv: string) => {
        if (path) {
            dispatch(setStockName(isu_kor_abbrv));
            navigate(path);
        }
    };

    return (
        <div className="table">
            <table className="table table-white table-hover">
                <colgroup>
                    <col style={{width: "15%"}} />
                    <col style={{width: "20%"}} />
                    <col style={{width: "65%"}} />
                </colgroup>
                <thead>
                    <tr>
                        <th className="text-center text-black3">
                            <p>순위</p>
                        </th>
                        <th className="text-center text-black3">
                            <p>종목명</p>
                        </th>
                        <th className="text-center text-black3">
                            <p>언급채널</p>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {contents.filter(content => {
                        return content.recommend === true;
                    })
                    .map((content, index) => (
                        <tr 
                            key={index} 
                            className="highlight" 
                            onClick={() => handleClick(`/stock/${content.isu_srt_cd}`, `${content.isu_kor_abbrv}`)} 
                            style={{ cursor: "pointer" }}>
                            <td className="text-center">
                                <small className="text-red fw-semibold small-test">추천</small>
                            </td>
                            <td className="text-black5"><p className="line-clamp p-test">{content.isu_kor_abbrv}</p></td>
                            <td className="px-3">
                                <a className="d-flex align-items-center gap-2">
                                    <div className="txt d-flex align-items-center gap-2">
                                        {(() => {
                                            const [displayText, extraText] = formatChannelList(content.channels, 3);
                                            return (
                                            <>
                                                <small className="text-black5 ellipsis-box small-test">{displayText}</small>
                                                {extraText && <p className="fw-semibold flex-shrink-0 p-test">{extraText}</p>}
                                            </>
                                            );
                                        })()}
                                    </div>
                                </a>
                            </td>
                        </tr>
                    ))}
                    {contents.filter(content => {
                        return content.recommend !== true;
                    })
                    .map((content, index) => (
                        <tr 
                            key={index}
                            onClick={() => handleClick(`/stock/${content.isu_srt_cd}`, `${content.isu_kor_abbrv}`)} 
                            style={{ cursor: "pointer" }}>
                            <></>
                            <td className="text-center">
                                <small className={`small-test number${index <= 2 ? " bg-red text-white" : ""}`}>{index + 1}</small>
                            </td>
                            <td className="text-black5"><p className="line-clamp p-test">{content.isu_kor_abbrv}</p></td>
                            <td className="px-3">
                                <a className="d-flex align-items-center gap-2" >
                                    <div className="txt d-flex align-items-center gap-2">
                                        {(() => {
                                            const [displayText, extraText] = formatChannelList(content.channels, 3);
                                            return (
                                            <>
                                                <small className="text-black5 ellipsis-box small-test">{displayText}</small>
                                                {extraText && <p className="fw-semibold flex-shrink-0 p-test">{extraText}</p>}
                                            </>
                                            );
                                        })()}
                                    </div>
                                </a>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default StockTable;